/**
 * Keep a non-translated record of the listing type names
 */
export const listingTypeTrackingName = {
  JOB: 'Job',
  INTERNSHIP: 'Internship',
  VOLOP: 'Volunteer Opportunity',
  EVENT: 'Event',
  ORG: 'Organization',
};
